/* =========================================================================
   WISEL · CINEMATIC — motor de animacion premium (ONER ACTIVE grade)
   -------------------------------------------------------------------------
   GSAP 3.13 (self-host, free incl. SplitText) + ScrollTrigger + SplitText.
   Eleva el word-reveal CSS basico a reveals de scroll ricos y suaves:
     · titulares por palabra/linea con stagger (SplitText)
     · secciones con entrada escalonada
     · parallax con scrub suave
     · magnetic CTA (SOLO desktop, fino)
   FAILSAFE TOTAL: si reduced-motion ON (caso dueno) o GSAP no carga ->
   estado final visible, 0 huecos, 0 error. Nunca toca buy-box/ATC (R-A1).
   ========================================================================= */
(function () {
  'use strict';

  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var FINE = !!(window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches);

  // Marca de que el motor JS esta vivo (el CSS usa .wz-cine-on para activar
  // estados de partida ocultos SOLO cuando sabemos que vamos a animar).
  // Si este JS no corre, el CSS deja todo visible por defecto -> sin huecos.
  function flagReady() {
    document.documentElement.classList.add('wz-cine-ready');
  }

  // ---- Si reduced-motion: NO animar nada. Todo queda en estado final. ----
  if (RM) { flagReady(); return; }

  // ---- Cargar GSAP. Si falla en X ms, failsafe: dejar todo visible. ----
  var BOOTED = false;
  var failsafe = setTimeout(function () {
    if (BOOTED) return;
    // GSAP no llego: garantizar visibilidad de cualquier estado de partida.
    document.documentElement.classList.add('wz-cine-failed');
  }, 1600);

  function boot() {
    if (BOOTED) return;
    if (!window.gsap) return;
    BOOTED = true;
    clearTimeout(failsafe);
    flagReady();

    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var Split = window.SplitText;
    if (ST) gsap.registerPlugin(ST);
    if (Split) gsap.registerPlugin(Split);

    document.documentElement.classList.add('wz-cine-on');

    // refresco de ScrollTrigger cuando entren fuentes/imagenes (evita posiciones erroneas)
    if (ST && document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ST.refresh(); });
    }

    /* ============================================================
       1 · SPLIT REVEAL de titulares (.wh-split / [data-wz-split])
       Palabras suben con mask + stagger, atado al scroll (suave).
       Failsafe: si SplitText no esta -> reveal de bloque simple.
       ============================================================ */
    var heads = [].slice.call(document.querySelectorAll('.wh-split, [data-wz-split]'));
    heads.forEach(function (el) {
      if (el.dataset.wzSplitDone) return;
      el.dataset.wzSplitDone = '1';

      var hasST = !!ST;
      var trig = hasST ? {
        trigger: el,
        start: 'top 88%',
        once: true
      } : null;

      if (Split) {
        var split;
        try {
          split = new Split(el, { type: 'lines,words', linesClass: 'wz-line', wordsClass: 'wz-word' });
        } catch (e) { split = null; }

        if (split && split.words && split.words.length) {
          // mask por linea para el efecto "sube desde abajo"
          (split.lines || []).forEach(function (ln) { ln.style.overflow = 'hidden'; ln.style.display = 'block'; });
          gsap.set(split.words, { yPercent: 116, opacity: 0 });
          gsap.to(split.words, {
            yPercent: 0, opacity: 1,
            duration: 0.82, ease: 'cubic-bezier(.16,1,.3,1)',
            stagger: 0.045,
            scrollTrigger: trig,
            onComplete: function () {
              // liberar para no romper line-breaks responsive: revertir a texto plano
              try { split.revert(); } catch (e) {}
            }
          });
          // si no hay ScrollTrigger, dispara ya
          if (!hasST) {
            gsap.fromTo(split.words, { yPercent: 116, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.82, ease: 'cubic-bezier(.16,1,.3,1)', stagger: 0.045 });
          }
          return;
        }
      }
      // ---- fallback sin SplitText: reveal de bloque ----
      gsap.fromTo(el, { y: 26, opacity: 0 }, {
        y: 0, opacity: 1, duration: 0.8, ease: 'cubic-bezier(.16,1,.3,1)',
        scrollTrigger: trig
      });
    });

    /* ============================================================
       2 · REVEAL escalonado de bloques ([data-wz-rise], .wz-rise)
       fade + subida, stagger por hijos si los hay.
       ============================================================ */
    if (ST) {
      var rises = [].slice.call(document.querySelectorAll('[data-wz-rise]'));
      rises.forEach(function (grp) {
        var kids = grp.children && grp.children.length ? [].slice.call(grp.children) : [grp];
        gsap.fromTo(kids, { y: 30, opacity: 0 }, {
          y: 0, opacity: 1, duration: 0.7, ease: 'cubic-bezier(.16,1,.3,1)',
          stagger: 0.08,
          scrollTrigger: { trigger: grp, start: 'top 86%', once: true }
        });
      });
    }

    /* ============================================================
       3 · PARALLAX con scrub suave ([data-wz-parallax])
       La imagen interna se desplaza ±parallax px al scrollear.
       Mas rico/suave que rAF manual. Solo transform (GPU).
       ============================================================ */
    if (ST) {
      var pxs = [].slice.call(document.querySelectorAll('[data-wz-parallax]'));
      pxs.forEach(function (wrap) {
        var img = wrap.querySelector('img, video, .wz-parallax__layer');
        if (!img) return;
        var amt = parseFloat(wrap.getAttribute('data-wz-parallax')) || 8; // % de su alto
        gsap.fromTo(img, { yPercent: -amt }, {
          yPercent: amt, ease: 'none',
          scrollTrigger: { trigger: wrap, start: 'top bottom', end: 'bottom top', scrub: 0.6 }
        });
      });
    }

    /* ============================================================
       4 · MAGNETIC CTA ([data-wz-magnetic]) — SOLO desktop fino.
       El boton se imanta unos px hacia el cursor. quickTo = suave.
       Off en touch / RM (ya retornado arriba).
       ============================================================ */
    if (FINE) {
      var mags = [].slice.call(document.querySelectorAll('[data-wz-magnetic]'));
      mags.forEach(function (btn) {
        var xTo = gsap.quickTo(btn, 'x', { duration: 0.4, ease: 'power3.out' });
        var yTo = gsap.quickTo(btn, 'y', { duration: 0.4, ease: 'power3.out' });
        var STR = 0.32; // fuerza del iman
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          var mx = e.clientX - (r.left + r.width / 2);
          var my = e.clientY - (r.top + r.height / 2);
          xTo(mx * STR); yTo(my * STR);
        });
        btn.addEventListener('mouseleave', function () { xTo(0); yTo(0); });
      });
    }
  }

  // Cargar el bundle self-hosted. Si window.gsap ya existe (otro script), boot directo.
  if (window.gsap) { boot(); return; }
  var s = document.querySelector('script[data-wz-gsap]');
  if (s) {
    if (s.dataset.loaded === '1') boot();
    else s.addEventListener('load', boot);
    s.addEventListener('error', function () { document.documentElement.classList.add('wz-cine-failed'); });
  } else {
    // por si el snippet no inyecto el <script>: failsafe ya activo, no bloquear.
  }

  // arrancar tambien en DOMContentLoaded por si el script tag carga antes del DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { if (window.gsap) boot(); });
  }
})();
